import React, {useContext} from 'react';
import {Button} from '../../Form/Button/Button';
import {buttonColors} from '../../Pickers/InputTheme';
import './QuestionOptions.scss';
import {I18nReactContext} from "../../../contexts/I18nContext";
import {QuestionnaireReactContext} from "../../../contexts/QuestionnaireContext/QuestionnaireContext";
import {find, get, map} from "lodash";
import {useContextSelector} from 'use-context-selector';
import {QuestionOption} from "./QuestionOption/QuestionOption";


export const QuestionOptions = ({questionId}) => {
    const {i18n} = useContext(I18nReactContext);
    const activeQuestionId = useContextSelector(QuestionnaireReactContext, (context) => context.activeQuestionId)
    const addOption = useContextSelector(QuestionnaireReactContext, (context) => context.addOption)
    const options = useContextSelector(QuestionnaireReactContext, (context) => {
        const question = find(get(context, `questionnaireQuestions`, []), {id: questionId})
        return get(question, 'options', [])
    })

    const isActive = activeQuestionId === questionId
    return (
        <>
            <div className={`options-list ${isActive ? 'focused' : ''}`} data-testid="question-options-list">
                {map(options, (option, index) => {
                    return <QuestionOption key={option.id} optionId={option.id} questionId={questionId} questionIndex={index}/>
                })}
                {isActive ? <Button
                    className={"add-option"}
                    color={buttonColors.YELLOW}
                    onClick={addOption}
                    text={String(i18n.translate('questionnaireQuestions.buttons.addOption'))}
                    dataTestId="add-option-button"
                /> : ''}
            </div>
        </>
    );
};

